export default __webpack_public_path__ + "static/bncff-web-site-2-mobile-697e3aaa04ac9f17e9f85a2bd7ec43c2.jpg";